
    <mat-form-field [formGroup]="form">
      <mat-label>{{title}}</mat-label>
      <mat-chip-grid #chipGrid aria-label="Fruit selection">
        <mat-chip-row *ngFor="let dato of datiSelezionati();" (removed)="remove(dato)">
          {{dato}}
          <button matChipRemove [attr.aria-label]="'remove ' + dato">
            <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          </button>
        </mat-chip-row>
      </mat-chip-grid>
      <input
        [name]="name"
        [placeholder]="placeholder"
        [formControlName]="name"
        #luogoInput
        [ngModel]="currentValue()"
        (ngModelChange)="currentValue.set($event)"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (input)="filtereddatiSelezionati()"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let datoFiltered of filteredDatiSelezionati(); " [value]="datoFiltered">
          {{datoFiltered}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    